import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3c7a71d5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sms-campaigns-header-create" };
import SmsBalance from '@/features/SMSCampaigns/components/SMSBalance.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSCampaignsHeaderCreate',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_base_card_header = _resolveComponent("base-card-header");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_base_card_header, {
                    title: _ctx.$t('sms-campaigns.header.create'),
                    svg: "menu/sms"
                }, null, 8, ["title"]),
                _createVNode(SmsBalance)
            ]));
        };
    }
});
